<template>
  <div class="insight-jakarta" v-if="countLinkurl>0">
    <div class="row">
      <div class="col-12">
        <h5
          class="title-insight"
          @mouseover="accebility('dashboard satudata')"
          v-if="showTitle"
          v-bind:style="insightjakartaAccebility(isAccebility)"
        >
          <img
            class="image-title"
            v-bind:src="require('@/assets/icon/icon-title.png')"
          />DASHBOARD SATUDATA
        </h5>
        <h5
          class="title-opendata"
          @mouseover="accebility('tantangan jakarta')"
          v-else
          v-bind:style="insightjakartaAccebility(isAccebility)"
        >
          DASHBOARD SATUDATA
        </h5>
      </div>
      <div class="col-12 carousel">
        <Carousel v-bind="settings" :autoplay="4000" :breakpoints="breakpoints">
          <Slide v-for="slide in data" :key="slide">
            <div class="carousel__item" v-if="slide.link_url">
              <div class="card" @mouseover="accebility(slide.desc)">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12">
                      <h5 class="card-title">{{ slide.title }}</h5>
                    </div>
                    <div class="col-4">
                      <img
                        v-bind:src="
                          baseApi +'/uploads/img/300/'+ slide.path_cover
                        "
                        class="card-img-top"
                        width="100%"
                      />
                    </div>
                    <div class="col-8">
                      <p class="card-desc">{{ limitTitle(slide.desc, 120) }}</p>
                    </div>
                    <div class="col-12" align="left">
                      <span class="date"
                        ><i class="fa fa-calendar" aria-hidden="true"></i
                        >{{ toDate(currentDate) }}</span
                      >
                      <!-- <span class="views"
                        ><i class="fa fa-eye" aria-hidden="true"></i
                        >{{ slide.jumlah_insight }}</span
                      > -->
                      <a
                        v-bind:href="
                          '/opendata-dashboard/detail?kategori=' +
                          slide.title +
                          '&link_url=' +
                          slide.link_url
                        "
                        ><button class="button-page">
                          Lihat Selengkapnya
                          <i
                            class="fa fa-chevron-right"
                            aria-hidden="true"
                          ></i></button
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Slide>
          <template #addons>
            <Navigation />
          </template>
        </Carousel>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
export default {
  name: "InsightJakartaComponents",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data() {
    return {
      baseApi: this.$store.state.apiUrl,
      data: [],
      countLinkurl:0,
      showTitle: true,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        400: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        700: {
          itemsToShow: 3.5,
          snapAlign: "center",
        },
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
      isAccebility: this.$store.state.isAccebility,
      currentDate: "0",
    };
  },
  mounted() {
        
    axios.get(`${this.baseApi}/api/v2/satudata/dashboard-satudata-jakarta`).then((res) => {
      let datas = res.data.data
      this.data = datas
      let countLinkurls = []
      for(let i=0; i<datas.length; i++){
        if(datas[i].link_url){
          countLinkurls.push(datas[i].link_url)
        }
      }
      this.countLinkurl = countLinkurls.length
    });

    if (this.$route.meta.page == "open-data") {
      this.showTitle = false;
    }

    let date = new Date();
    let month = date.getMonth() + 1;
    this.currentDate = date.getFullYear() + "-" + month + "-" + date.getDay();
  },
  methods: {
    insightjakartaAccebility(isAccebility) {
      if (isAccebility.modeMalam) {
        return {
          color: "white",
        };
      } else {
        return {
          color: "#052158",
        };
      }
    },
    limitTitle(string = "", limit = 0) {
      if (string) {
        let next = "";
        if (string.length > 28) {
          next = " ...";
        }
        return string.substring(0, limit) + next;
      }
    },
    /*eslint no-mixed-spaces-and-tabs: ["error", "smart-tabs"]*/
    toDate(items) {
      let dates = new Date(items);
      //let month = ("0" + (dates.getMonth() + 1)).slice(-2)
      let month = dates.toLocaleString("id-ID", { month: "long" });
      let date = ("0" + (dates.getDay() + 1)).slice(-2);
      return date + " " + month + " " + dates.getFullYear();
      //   return date+'-'+month+'-'+dates.getFullYear()
    },
    accebility(voice) {
      if (this.isAccebility.modeSuara) {
        let msg = new SpeechSynthesisUtterance();
        let voices = window.speechSynthesis.getVoices();
        msg.voice = voices[160];
        msg.text = voice;
        msg.volume = 10;
        msg.rate = 1;
        msg.pitch = 1;
        window.speechSynthesis.cancel();
        window.speechSynthesis.speak(msg);
      }
    },
  },
};
</script>
